import { useMemo } from 'react';
import styled from 'styled-components';

// 状态文本颜色 [文本颜色 ,背景颜色]
const StateTextColor: Record<string, [string, string]> = {
  Active: ['#388506', 'rgba(166, 235, 122, 0.20);'],
  Frozen: ['#ff1b1b', '#ffdfdf'],
  Spent: ['#141413', '#F3F5F2'],
  Thawed: ['#141413', '#F3F5F2'],
};

export const CommitmentStatus: React.FC<{
  is_frozen: boolean;
  is_spent: boolean;
}> = ({ is_frozen, is_spent }) => {
  const state = useMemo(() => {
    let status = 'Active';
    if (is_frozen) status = 'Frozen';
    if (is_spent) status = 'Spent';
    if (is_frozen && is_spent) status = 'Thawed';
    return status;
  }, [is_frozen, is_spent]);

  return <StateText $stateColor={StateTextColor[state]}>{state}</StateText>;
};

const StateText = styled.span<{ $stateColor: [string, string] }>`
  font-size: 14px;
  color: ${({ $stateColor }) => $stateColor[0]};
  background-color: ${({ $stateColor }) => $stateColor[1]};
  text-align: center;
  border-radius: 4px;
  padding: 4px 6px;
`;
